<template>
	<div ref="carInputBoxRef">
		<div class="car_input_box">
			<!-- <div>请输入正确的车牌</div> -->
			<div class="car_type" @click="boardShow = true">
				<div
					class="default_car"
					:class="{ active_car: activeNum == '0' }"
					@click="chooseNumber(carNumber[0], '0')"
				>
					<div class="" v-show="carNumber[0]">
						{{ carNumber[0] }}
					</div>
				</div>
				<div
					class="default_car default_car1"
					:class="{ active_car: activeNum == '1' }"
					@click="chooseNumber(carNumber[1], '1')"
				>
					<div class="" v-show="carNumber[1]">
						{{ carNumber[1] }}
					</div>
				</div>
				<div class="default_dot"></div>
				<div
					class="default_car"
					:class="{ active_car: activeNum == '2' }"
					@click="chooseNumber(carNumber[2], '2')"
				>
					<div class="" v-show="carNumber[2]">
						{{ carNumber[2] }}
					</div>
				</div>
				<div
					class="default_car"
					:class="{ active_car: activeNum == '3' }"
					@click="chooseNumber(carNumber[3], '3')"
				>
					<div class="" v-show="carNumber[3]">
						{{ carNumber[3] }}
					</div>
				</div>
				<div
					class="default_car"
					:class="{ active_car: activeNum == '4' }"
					@click="chooseNumber(carNumber[4], '4')"
				>
					<div class="" v-show="carNumber[4]">
						{{ carNumber[4] }}
					</div>
				</div>
				<div
					class="default_car"
					:class="{ active_car: activeNum == '5' }"
					@click="chooseNumber(carNumber[5], '5')"
				>
					<div class="" v-show="carNumber[5]">
						{{ carNumber[5] }}
					</div>
				</div>
				<div
					class="default_car"
					:class="{ active_car: activeNum == '6' }"
					@click="chooseNumber(carNumber[6], '6')"
				>
					<div class="" v-show="carNumber[6]">
						{{ carNumber[6] }}
					</div>
				</div>
				<div
					class="default_car default_car--new_power"
					:class="{
						active_car: activeNum == '7',
						holder: !carNumber[7]
					}"
					@click="chooseNumber(carNumber[7], '7')"
				>
					<div class="num" v-show="carNumber[7]">
						{{ carNumber[7] }}
					</div>
				</div>
			</div>
			<!-- <div class="check_energy">
				<van-checkbox
					:value="currentIndex == 1"
					@click="chooseIsNewEnergy"
				></van-checkbox>
				<div>新能源车牌号</div>
			</div> -->
			<!-- <div class="confirm_btn" @click="submit">确认</div> -->
		</div>
		<!-- <div class="tips">注: 请认真核对车牌，以免支付错误！</div> -->
		<!-- 键盘 -->
		<div class="keyboard-content" v-show="boardShow">
			<!-- 省份键盘 -->
			<div v-show="provinceBoardShow" style="position: relative">
				<div class="province-keyboard flex jus-center">
					<div
						class="td-nor color-333 province-td"
						v-for="(item, index) in provincesKeyList"
						:key="index"
						@click="provinceKeyClick(item, index)"
						hover-class="board-active"
						hover-start-time="0"
						hover-stay-time="80"
					>
						<div class="province-font">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="province-keyboard flex jus-center">
					<div
						class="td-nor color-333 province-td"
						v-for="(item, index) in provincesKeyTwo"
						:key="index"
						@click="provinceKeyClick(item, index)"
						hover-class="board-active"
						hover-start-time="0"
						hover-stay-time="80"
					>
						<div class="province-font">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="province-keyboard flex jus-center">
					<div
						class="td-nor color-333 province-td"
						v-for="(item, index) in provincesKeyThree"
						:key="index"
						@click="provinceKeyClick(item, index)"
						hover-class="board-active"
						hover-start-time="0"
						hover-stay-time="80"
					>
						<div class="province-font">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="province-keyboard flex">
					<div
						class="td-nor color-333 province-td"
						v-for="(item, index) in provincesKeyFour"
						:key="index"
						@click="provinceKeyClick(item, index)"
						hover-class="board-active"
						hover-start-time="0"
						hover-stay-time="80"
					>
						<div class="province-font">
							{{ item }}
						</div>
					</div>
				</div>
				<div @click.stop="backspace" class="delete flex del-province">
					<span>del</span>
				</div>
			</div>
			<!--数字键盘-->
			<div v-show="!provinceBoardShow" class="number-keyboard flex between">
				<div
					class="td td-num color-333"
					:class="numberIsDis ? 'board-active' : ''"
					v-for="(item, index) in numberKeyList"
					:key="index"
					@click="numberKeyClick(item, index)"
					:hover-class="numberIsDis ? '' : 'board-active'"
					hover-start-time="0"
					hover-stay-time="80"
				>
					{{ item }}
				</div>
			</div>
			<!--字母键盘-->
			<div v-show="!provinceBoardShow">
				<div class="english-keyboard flex between">
					<div
						class="td td-num color-333"
						:class="englishIsDis ? 'board-active' : ''"
						v-for="(item, idx) in englishKeyOneList"
						:key="idx"
						@click="englishKeyClick(item, idx)"
						:hover-class="englishIsDis ? '' : 'board-active'"
						hover-start-time="0"
						hover-stay-time="80"
					>
						{{ item }}
					</div>
				</div>
				<!-- 最后一行 -->
				<div class="english-keyboard flex between">
					<div
						class="td td-num color-333"
						:class="englishIsDis ? 'board-active' : ''"
						v-for="(item, index) in englishKeyTwoList"
						:key="index"
						@click="englishKeyClick(item, index)"
						:hover-class="englishIsDis ? '' : 'board-active'"
						hover-start-time="0"
						hover-stay-time="80"
					>
						{{ item }}
					</div>

					<!-- 挂字键 -->
					<!-- <div @click="trailerFiledClick('港')" class="td td-num color-333"
							:class="trailerFiledIsDis ? 'board-active' : ''"
							:hover-class="trailerFiledIsDis ? '' : 'board-active'" hover-start-time="0"
							hover-stay-time="80">港</div> -->
					<div
						@click="trailerFiledClick('澳')"
						class="td td-num color-333"
						:class="trailerFiledIsDis ? 'board-active' : ''"
						:hover-class="trailerFiledIsDis ? '' : 'board-active'"
						hover-start-time="0"
						hover-stay-time="80"
					>
						澳
					</div>
					<div
						@click="trailerFiledClick('学')"
						class="td td-num color-333"
						:class="trailerFiledIsDis ? 'board-active' : ''"
						:hover-class="trailerFiledIsDis ? '' : 'board-active'"
						hover-start-time="0"
						hover-stay-time="80"
					>
						学
					</div>
					<div
						@click="trailerFiledClick('挂')"
						class="td td-num color-333"
						:class="trailerFiledIsDis ? 'board-active' : ''"
						:hover-class="trailerFiledIsDis ? '' : 'board-active'"
						hover-start-time="0"
						hover-stay-time="80"
					>
						挂
					</div>
					<div
						@click="trailerFiledClick('警')"
						class="td td-num color-333"
						:class="trailerFiledIsDis ? 'board-active' : ''"
						:hover-class="trailerFiledIsDis ? '' : 'board-active'"
						hover-start-time="0"
						hover-stay-time="80"
					>
						警
					</div>
					<div @click.stop="backspace" class="delete flex">
						<span>delete</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'add-car-input',
	data() {
		return {
			current: 0,
			carNumber: [],
			carTypeList: [
				{
					text: '新能源',
					value: 1
				}
			],
			currentIndex: 0,
			provincesKeyList: '京津冀晋蒙辽吉黑',
			provincesKeyTwo: '沪苏浙皖闽赣鲁豫',
			provincesKeyThree: '鄂湘粤桂琼渝川贵',
			provincesKeyFour: '云藏陕甘青宁新',
			provinceBoardShow: true, // 显示省键盘
			boardShow: false, // 显示键盘
			numberKeyList: '1234567890'.split(''),
			numberIsDis: true, // 输入键盘不可点击 true为不可点击
			englishIsDis: false, // 字母键盘可点击
			englishKeyOneList: 'ABCDEFGHJKLMNPQRSTUV'.split(''),
			englishKeyTwoList: 'WXYZ',
			trailerFiledIsDis: true, // 挂字禁用
			activeNum: '0',
			isClickCarNum: false,
			isCheckEnergy: false
		}
	},
	mounted() {
		document.body.addEventListener('click', this.hideClickBackGround)
	},
	unmounted() {
		document.body.removeEventListener('click', this.hideClickBackGround)
	},
	watch: {
		'carNumber.length': {
			handler(newVal, oldValue) {
				console.log(newVal, oldValue, 'newVal, oldValue')
				this.setTrailerKeyboardDis()
			},
			deep: true
		}
	},
	methods: {
		//  确定按钮
		validate(carPlate) {
			return new Promise((resolve, reject) => {
				if (!carPlate) {
					carPlate = this.carNumber.join('')
				}
				// 普通车车牌校验
				const carCardP =
					/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
				// 新能源车牌校验（8位）
				const carCardD =
					/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{6}$/

				console.log(this.carNumber, carPlate, 'carNumber')
				if (!carPlate) {
					reject(new Error('请输入车牌号'))
				}
				// 普通车或新能源，只要匹配任意一种就放行
				const isValid = carCardP.test(carPlate) || carCardD.test(carPlate)
				if (!isValid) {
					reject(new Error('车牌号输入有误'))
				}
				resolve()
			})
		},
		// 点击车牌号输入框
		chooseNumber(item, active) {
			console.log(item, active, 'itemsss')
			if (active == 1) {
				// 第二位
				this.numberIsDis = true
				this.provinceBoardShow = false
			} else if (active == '0') {
				// 第一位
				this.provinceBoardShow = true
				this.numberIsDis = true
			} else {
				this.numberIsDis = false
				this.provinceBoardShow = false
			}
			// if (this.currentIndex == 0 && active == '7') {
			// 普通车牌 不让点击7位
			// } else {
			this.activeNum = active
			this.current = active
			this.isClickCarNum = true
			// }
			// if (
			// 	(this.currentIndex == 0 &&
			// 		this.carNumber.length >= 6 &&
			// 		this.current >= 6) ||
			// 	(this.currentIndex == 1 &&
			// 		this.carNumber.length >= 7 &&
			// 		this.current >= 7)
			// ) {
			// 	this.trailerFiledIsDis = false
			// } else {
			// 	this.trailerFiledIsDis = true
			// }
			this.setTrailerKeyboardDis()
		},
		// 点击新能源或者普通车
		// chooseIsNewEnergy() {
		// 	console.log(this.carNumber, '切换新能源')
		// 	if (this.currentIndex == 1) {
		// 		this.currentIndex = 0
		// 		if (this.carNumber.length == 8) {
		// 			this.carNumber.pop()
		// 		}
		// 	} else {
		// 		this.currentIndex = 1
		// 		if (this.carNumber.length == 7) {
		// 			this.current = 7
		// 			this.activeNum = 7
		// 		}
		// 	}
		// 	// console.log(this.carNumber, '切换新能源后')
		// 	this.$forceUpdate()
		// },
		// 省份键盘
		provinceKeyClick(val, index) {
			console.log(
				this.currentIndex,
				this.carNumber.length,
				'this.carNumber.length省'
			)
			this.carNumber[0] = val
			this.provinceBoardShow = false
			this.numberIsDis = true
			this.englishIsDis = false
			this.current++
			this.activeNum = this.current
			this.$forceUpdate()
			console.log(this.current, 'current')
		},
		// 数字键盘
		numberKeyClick(val, idx) {
			let flag = this.carNumber.indexOf('') === -1
			console.log(
				this.currentIndex,
				this.carNumber,
				flag,
				this.carNumber.length,
				'this.carNumber.length数字'
			)
			if (this.numberIsDis) return
			// if (
			// 	(this.currentIndex == 0 &&
			// 		this.carNumber.length >= 7 &&
			// 		this.current >= 7) ||
			// 	(this.currentIndex == 1 &&
			// 		this.carNumber.length >= 8 &&
			// 		this.current >= 8)
			// ) {
			// 	return
			// }

			if (this.carNumber.length >= 8 && this.current >= 8) {
				return
			}
			console.log(111)
			if (this.current == 7) {
				console.log('是新能源了')
				this.currentIndex = 1 // 是新能源了
			}

			this.carNumber[this.current] = val
			this.current++
			this.setTrailerKeyboardDis()
			this.$forceUpdate()
			this.activeNum = this.current
			this.numberIsDis = false
			console.log(this.current, 'current')
			console.log(
				this.currentIndex,
				this.carNumber,
				flag,
				this.carNumber.length,
				'this.carNumber.length数字后'
			)
		},
		// 字母键盘
		englishKeyClick(val, idx) {
			let flag = this.carNumber.indexOf('') === -1
			console.log(
				this.currentIndex,
				this.carNumber,
				flag,
				this.carNumber.length,
				'this.carNumber.length字母'
			)
			// this.activeNum = this.carNumber.length
			if (this.englishIsDis) return
			// if (
			// 	(this.currentIndex == 0 &&
			// 		this.carNumber.length >= 7 &&
			// 		this.current >= 7) ||
			// 	(this.currentIndex == 1 &&
			// 		this.carNumber.length >= 8 &&
			// 		this.current >= 8)
			// ) {
			// 	return
			// }
			if (this.carNumber.length >= 8 && this.current.length >= 8) {
				return
			}
			console.log(222)
			this.current++
			this.carNumber[this.current - 1] = val
			console.log(this.current, 'this.current 字母键盘')
			if (this.current == 2) this.numberIsDis = false
			this.setTrailerKeyboardDis()
			this.$forceUpdate()
			this.activeNum = this.current
			this.numberIsDis = false
			console.log(this.current, 'current')
			console.log(
				this.currentIndex,
				this.carNumber,
				flag,
				this.carNumber.length,
				'this.carNumber.length字母后'
			)
		},
		// 设置挂车键盘禁用（只能最后一个选择挂）
		setTrailerKeyboardDis() {
			if (
				(this.currentIndex == 0 &&
					this.carNumber.length >= 6 &&
					this.current >= 6) ||
				(this.currentIndex == 1 &&
					this.carNumber.length >= 7 &&
					this.current >= 7)
			) {
				this.trailerFiledIsDis = false
			} else {
				this.trailerFiledIsDis = true
			}
		},
		// 点击挂字
		trailerFiledClick(val) {
			console.log(val, this.trailerFiledIsDis, '挂字')
			if (this.trailerFiledIsDis) return
			if (
				(this.currentIndex == 0 &&
					this.carNumber.length >= 7 &&
					this.current >= 7) ||
				(this.currentIndex == 1 &&
					this.carNumber.length >= 8 &&
					this.current >= 8)
			) {
				console.log(111222)
				return
			}
			this.current++
			this.carNumber[this.current - 1] = val
			this.activeNum = this.current
			this.$forceUpdate()
			console.log(this.carNumber, this.current, 'gua')
		},
		// 删除键
		backspace() {
			console.log(this.current, 'current')
			if (this.current < 0) return
			if (this.current == 0) {
				this.provinceBoardShow = true
				this.activeNum = 0
				this.carNumber[0] = ''
				console.log(this.carNumber[0], 'this.carNumber[0]')
				this.$forceUpdate()
				return
				// this.numberIsDis = true
				// this.englishIsDis = true
				// this.trailerFiledIsDis = true
			} else if (this.current == 1) {
				this.provinceBoardShow = true
				this.activeNum = 1
				this.carNumber[1] = ''
			} else if (this.current == 2) {
				this.provinceBoardShow = false
				this.numberIsDis = true
				this.carNumber[this.current] = ''
			} else {
				this.provinceBoardShow = false
				// this.carNumber[this.current - 1] = ''
				this.carNumber[this.current] = ''
			}
			// if (
			// 	(this.currentIndex == 0 && this.current <= 6) ||
			// 	(this.currentIndex == 1 && this.current <= 7)
			// ) {
			// 	this.trailerFiledIsDis = true
			// } else {
			// 	this.trailerFiledIsDis = false
			// }
			this.setTrailerKeyboardDis()
			this.current--
			if (this.current < 7) {
				this.currentIndex = 0 // 不是新能源了
			}
			this.activeNum = this.current
			this.$forceUpdate()
			console.log(this.carNumber, '删除后车牌号')
		},
		hideClickBackGround(event) {
			const clickSelf = this.$refs.carInputBoxRef.contains(event.target)
			if (!clickSelf) this.boardShow = false
		},
		async setCarNumber(value) {
			if (!value) return
			const plateArr = value.split('')
			this.currentIndex = plateArr.length >= 8 ? 1 : 0
			await this.validate(value)
			this.carNumber = plateArr
			this.current = this.carNumber.length
			this.activeNum = this.current
			this.setTrailerKeyboardDis()
			this.$forceUpdate()
		}
	}
}
</script>

<style lang="scss" scoped>
.containers {
	box-sizing: border-box;
}

.parking-box {
	width: 100%;
	height: 254px;
	background: linear-gradient(180deg, #11b690 0%, #11b690 100%);
	font-size: 44px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	text-align: center;
	padding-top: 52px;
	box-sizing: border-box;
}

.car_input_box {
	height: auto;
	font-size: 32px;
	font-weight: 400;
	color: #333333;
	text-align: center;
	box-sizing: border-box;
}

@keyframes fade {
	from {
		opacity: 1;
	}

	50% {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@-webkit-keyframes fade {
	from {
		opacity: 1;
	}

	50% {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

.flex {
	display: flex;
}

.between {
	justify-content: space-between;
	align-items: center;
}

.font-30 {
	font-size: 30px;
}

.color-333 {
	color: #333333;
}

.car_type {
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
	width: 100%;
	align-items: center;
}

.default_car {
	width: 72px;
	height: 94px;
	background: #ffffff;
	border-radius: 4px;
	border: 2px solid rgba(0, 0, 0, 0.1);
	text-align: center;
	line-height: 94px;
	font-size: 40px;
	font-weight: bold;
	color: #333333;
}

.default_car--new_power {
	position: relative;
	background-color: #f0fffa;
	&.holder::before {
		content: '新能源';
		font-size: 24px;
		display: flex;
		white-space: wrap;
		width: 1em;
		text-align: center;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		color: #3af5b7;
		line-height: 1.1;
	}
	.num {
		position: relative;
	}
}

.line {
	color: #ea4070;
	border-radius: 2px;
	animation: fade 1500ms infinite;
	-webkit-animation: fade 1500ms infinite;
}

.car_type_box {
	display: flex;
	justify-content: start;
	width: 390px;
	margin: 0 auto;
}

.car_type_item {
	width: 130px;
	height: 69px;
	border: 1px solid #999999;
	text-align: center;
	line-height: 69px;
	font-size: 30px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #999999;
}

.check_energy {
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #6d7278;
	display: flex;
	justify-content: flex-end;
	margin-top: 16px;
}

.check_energy img {
	width: 32px;
	height: 32px;
	margin-right: 8px;
}

.car_type_item:nth-child(1) {
	border-radius: 6px 0px 0px 6px;
	border-right: 0.5px solid #999999;
}

.car_type_item:nth-child(2) {
	border-right: none;
	border-left: none;
}

.car_type_item:nth-child(3) {
	border-radius: 0px 6px 6px 0px;
}

.active {
	width: 130px;
	height: 69px;
	border: 1px solid #999999;
	text-align: center;
	line-height: 69px;
	font-size: 30px;
	font-family: PingFang SC;
	font-weight: 500;
	font-weight: bold;
	color: #ea4070;
	background: rgba(#ea4070, 0.1);
}

.active:nth-child(1) {
	border-radius: 6px 0px 0px 6px;
	border-right: 0.5px solid #999999;
}

.active:nth-child(2) {
	border-right: none;
	border-left: none;
}

.active:nth-child(3) {
	border-radius: 0px 6px 6px 0px;
}

.tips {
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #6d7278;
	margin: 16px 24px;
}

.add_car_box {
	width: calc(100% - 64px);
	height: 80px;
	background: linear-gradient(180deg, #df4270, #f299ab);
	border-radius: 40px;
	margin: 0 auto;
}

.add_car {
	height: 100%;
	line-height: 80px;
	font-size: 34px;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
}

.dis_car {
	height: 100%;
	line-height: 80px;
	font-size: 34px;
	font-weight: 500;
	color: #ffffff;
	background: #999999;
	text-align: center;
	border-radius: 40px;
}

.keyboard-content {
	width: 100%;
	height: 470px;
	box-sizing: border-box;
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 9;
	background-color: rgba(205, 208, 212, 0.92);
	padding-top: 13px;
}

.td {
	font-family: 'PingFangSC';
	font-size: 34px;
	color: #333333;
	font-weight: 500;
	margin: 12px 1px;
	background: #fcfcfe;
	box-shadow: 0px 2px 0px 0px #898a8d;
	border-radius: 9px;
	height: 84px;
	line-height: 84px;
	text-align: center;
	background-color: #fff;
}

.province-keyboard {
	margin: 0 5px;
	padding: 0 10px;
	// flex-wrap: wrap;
}

.td-nor {
	// flex: 0 1 9%;
	// margin-right: 3px;
}

.number-keyboard {
	margin: 0 5px;
}

.board-active {
	box-shadow: 0 0 0 #e5e5e5;
	background: #e5e5e5;
}

.english-keyboard {
	margin: 0 5px;
	flex-wrap: wrap;
}

.td-num {
	flex: 0 1 9%;
}

.board-active {
	box-shadow: 0 0 0 #e5e5e5;
	background: #e5e5e5;
}

.delete {
	width: 144px;
	height: 88px;
	text-align: center;
	background-color: #aaadb7;
	border-radius: 8px;
	color: #fff;
	// position: absolute;
	// right: 8px;
	// bottom: 30px;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 2px 0px 0px #898a8d;
}

.del-province {
	position: absolute;
	right: 28px;
	bottom: 13px;
	width: 64px;
	box-shadow: 0px 2px 0px 0px #898a8d;
	border-radius: 9px;
	font-family: 'PingFangSC';
	font-size: 34px;
	font-weight: 500;
	// margin: 12px auto;
	background: #fcfcfe;
	box-shadow: 0px 2px 0px 0px #898a8d;
	border-radius: 9px;
	height: 84px;
	line-height: 84px;
	text-align: center;
	background: #aaadb7;
}

.sure {
	width: 100px;
	height: 84px;
	text-align: center;
	background-color: #afb2bc;
	border-radius: 8px;
	position: absolute;
	right: 10px;
	bottom: 30px;
	justify-content: center;
	align-items: center;
}

.default_dot {
	width: 8px;
	height: 8px;
	background: #333333;
	margin: 0 4px;
}

.del-con {
	width: 44px;
	height: 32px;
}

.jus-center {
	justify-content: center;
}

.diabled_car {
	background: #f5f5f5;
	border-radius: 4px;
	border: 2px solid rgba(0, 0, 0, 0.1);
}

.active_car {
	border-radius: 4px;
	border: 2px solid #375de9;
}

.province-mr {
	margin-right: 10px;
}

.confirm_btn {
	width: 662px;
	height: 92px;
	line-height: 92px;
	background: #11b690;
	font-size: 32px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	border-radius: 46px;
	margin-top: 40px;
}

.province-td {
	width: 12.5%;
}

.province-font {
	width: 64px;
	box-shadow: 0px 2px 0px 0px #898a8d;
	border-radius: 9px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-size: 34px;
	color: #000;
	font-weight: 500;
	margin: 12px auto;
	box-shadow: 0px 2px 0px 0px #898a8d;
	border-radius: 9px;
	height: 84px;
	line-height: 84px;
	text-align: center;
	background-color: #fff;
}

.confirm-cash-box {
	width: 100vh;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.7);
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 99;
}

.cash-box {
	width: 570px;
	//height: 300px;
	background: rgb(223, 223, 223);
	border-radius: 28px;
	margin: 30vh auto 0;
	text-align: center;
	min-height: 200px;
}

.cash-title {
	font-size: 34px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #000000;
	padding-top: 38px;
	margin: 0 0 24px;
}

.content-cash {
	font-size: 26px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #000000;
	margin-bottom: 54px;
	padding: 0 32px;
}

.line-cash {
	width: 100%;
	height: 1px;
	background: rgba(60, 60, 67, 0.29);
}

.cancel-box {
	width: 100%;
	height: 88px;
	line-height: 88px;
	color: #11b690;
	font-size: 32px;
	text-align: center;
}

.flex-btwn {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
———————————————— 版权声明：本文为CSDN博主「小太阳呀！！」的原创文章，遵循CC 4.0
BY-SA版权协议，转载请附上原文出处链接及本声明。
原文链接：https://blog.csdn.net/m0_52685922/article/details/131436429
